import * as React from 'react';

import cx from 'clsx';
import styles from './Slider.module.scss';
import ArrowSlider from './Arrow';

interface CarouselSliderProps {
  children: React.ReactNode[];
  edgeSlidesPadding?: number;
  initialScroll?: {
    position: number;
    name: string;
  };
  styleProp?: 'slider' | 'arrowSlider';
}

const CarouselSlider: React.FC<CarouselSliderProps> = ({
  children,
  edgeSlidesPadding = 7,
  initialScroll,
  styleProp = 'slider',
}) => {
  const [preScrolled, setPreScrolled] = React.useState<boolean>(false);
  const arrowSliderElement = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (initialScroll) {
      const carousel = document.getElementById(`${initialScroll.name}`);
      if (carousel) {
        carousel.scrollLeft = initialScroll.position;
        setPreScrolled(true);
      }
    }
  }, [initialScroll]);

  const smoothDisabled =
    !!initialScroll && !!initialScroll.position && !preScrolled;

  return (
    <div className={styles.containerOuter}>
      <div
        className={cx(styles.container, !smoothDisabled && styles.smooth, {
          [styles[`sliderContainer${edgeSlidesPadding}`]]:
            styleProp === 'slider',
          [styles.sliderArrowContainer]:
            styleProp === 'arrowSlider' && children.length >= 5,
        })}
        id={`${initialScroll ? initialScroll.name : 'carousel-container'}`}
        data-testid="carousel-container"
        ref={arrowSliderElement}
      >
        {children.map((child, index) => (
          <div
            className={cx({
              [styles.sliderWrapper]: styleProp === 'arrowSlider',
              [styles.smooth]: styleProp === 'arrowSlider',
            })}
            data-testid="carousel-element"
            key={index}
          >
            {child}
          </div>
        ))}
      </div>
      {styleProp === 'arrowSlider' && children.length >= 5 ? (
        <div className={styles.smooth}>
          <ArrowSlider
            element={arrowSliderElement}
            scrollValue={25}
            disableValue={{ max: 300 }}
          />
          <ArrowSlider
            element={arrowSliderElement}
            scrollValue={-25}
            disableValue={{ min: 0 }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default CarouselSlider;
